module.exports = __webpack_public_path__ + "img/汪小我.d1f22f46.png";